<template>
  <div id="scrollTop" class="pop hide d-none d-md-block" @click="topSroll">
    <img src="../assets/img/top_arrow.png" alt="Topo" width="30px" title="Ir para o topo">
  </div>
</template>
<script>
export default {
  data () {
    return {
      scrollTop: null
    }
  },
  methods: {
    ScrollPage () {
      this.scrollTop = window.scrollY
      if (this.scrollTop > 300) {
        document.getElementById('scrollTop').classList.remove('hide')
      } else {
        document.getElementById('scrollTop').classList.add('hide')
      }
    },
    topSroll () {
      window.scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    }
  },
  mounted () {
    window.addEventListener('scroll', this.ScrollPage)
  }
}
</script>

<style lang="scss" scoped>
@import '../assets/scss/_variables.scss';

#scrollTop {
  bottom: 15px;
  cursor: pointer;
  position: fixed;
  right: 30px;
  transition: all 0.3s;
  z-index: 200;
  span {
    color: $primary;
    font-size: 18px;
    font-style: italic;
    font-weight: 300;
  }
  @media (max-width: 800px) {
    right: 10px;
  }
}

.hide {
  transition: all 0.3s;
  bottom: -50px!important;
}
@media (max-width: 1400px) {
 #scrollTop {
   span {
     display: none;
   }
 }
}
</style>



// WEBPACK FOOTER //
// src/components/ScrollTop.vue